import { render, staticRenderFns } from "./BookingAssistant4.vue?vue&type=template&id=3fc56f2d&scoped=true&lang=pug&"
import script from "./BookingAssistant4.vue?vue&type=script&lang=ts&"
export * from "./BookingAssistant4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc56f2d",
  null
  
)

export default component.exports